var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-navigation-drawer',{attrs:{"value":_vm.isOpen,"width":"320","absolute":"","temporary":"","right":"","hide-overlay":""},on:{"input":function($event){return _vm.$emit('state-change', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }